import { useEffect, useState } from "react";
import { useLocation } from "react-router";

import { ITabMenuTab } from "@digital-services/ui/types";

//
// This hook got overcomplicated because in CP codebase we have TabMenu issues in past, when we used SubMenu and first tab wasn't set active properly.
// eg. `/account` as tab and `/account/address` as sub tab (and trailing forward slash `/` played important role).
// But since Jul-2025 we removed CommerceService related code and there is no need to use `include()`
// Nevertheless, this hook is over-engineering and may be refactored or removed in future.
//
export const useTabIndex = (tabs: ITabMenuTab[]) => {
  const [currentTabIndex, setCurrentTabIndex] = useState(0);
  const { pathname } = useLocation();

  useEffect(() => {
    const tabIndex = tabs.findIndex(({ id }) =>
      pathname.toLowerCase().endsWith("/" + id.toLowerCase())
    );

    if (tabIndex === -1) {
      return setCurrentTabIndex(0);
    }

    setCurrentTabIndex(tabIndex);

    // When we use a constant-like `tabs` variable here as dependency trigger, it goes into WRONG update flow of `setCurrentTabIndex` which causes always be `0`
    // We must ignore `tabs` change, because it's initial data
    // eslint-disable-next-line
  }, [pathname]);

  return {
    currentTabIndex
  };
};
